// src/lib/stack-builder/synergy.ts
import {
	STACK_COMBINATIONS,
	BLEND_MATCHES,
	type StackCombination,
	type BlendMatch,
} from "@/config/peptide-stacks";

function sortPair(a: string, b: string): [string, string] {
	return a < b ? [a, b] : [b, a];
}

export function getPairwiseSynergy(slugA: string, slugB: string): StackCombination | null {
	if (slugA === slugB) return null;
	const [a, b] = sortPair(slugA, slugB);
	return STACK_COMBINATIONS.find((c) => c.peptides[0] === a && c.peptides[1] === b) ?? null;
}

export function getAllPairwiseSynergies(slugs: string[]): StackCombination[] {
	const results: StackCombination[] = [];
	for (let i = 0; i < slugs.length; i++) {
		for (let j = i + 1; j < slugs.length; j++) {
			const synergy = getPairwiseSynergy(slugs[i], slugs[j]);
			if (synergy) results.push(synergy);
		}
	}
	return results;
}

export function getAggregateScore(slugs: string[]): number | null {
	if (slugs.length < 2) return null;
	const synergies = getAllPairwiseSynergies(slugs);
	if (synergies.length === 0) return null;
	const avg = synergies.reduce((sum, s) => sum + s.synergyScore, 0) / synergies.length;
	return Math.round(avg);
}

export function detectBlendMatch(selectedSlugs: string[]): BlendMatch | null {
	const sorted = [...selectedSlugs].sort();
	return (
		BLEND_MATCHES.find((match) => {
			const matchSorted = [...match.individual].sort();
			return matchSorted.length === sorted.length && matchSorted.every((slug, i) => slug === sorted[i]);
		}) ?? null
	);
}
